module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "d-tasks",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
      }
    }
  }, [(_vm.isLoading) ? _c('Loader', {
    attrs: {
      "isSmall": true
    }
  }) : [_c('table', {
    staticClass: "d-table__inner"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "75%"
    }
  }, [_vm._v("Tildelt arbejdstid")]), _vm._v(" "), _c('th', {
    staticClass: "text-right"
  }, [_vm._v(_vm._s(_vm.tildeltArbejdstid))])]), _vm._v(" "), _c('tr', [_c('th', {
    staticStyle: {
      "width": "75%"
    }
  }, [_vm._v("Tildelt Undervisningstid")]), _vm._v(" "), _c('th', {
    staticClass: "text-right"
  }, [_vm._v(_vm._s(_vm.tildeltUndervisning))])]), _vm._v(" "), _c('tr', [_c('th', {
    staticStyle: {
      "width": "75%"
    }
  }, [_vm._v("Tildelt Undervisningstid uden UUV")]), _vm._v(" "), _c('th', {
    staticClass: "text-right"
  }, [_vm._v(_vm._s(_vm.tildeltUndervisningUdenUUV))])])])]), _vm._v(" "), _vm._l((_vm.tasksInTypes), function(type, idx) {
    return _c('table', {
      staticClass: "d-table__inner"
    }, [_c('thead', {
      staticClass: "d-table__inner__thead__small"
    }, [_c('tr', [_c('th', {
      staticStyle: {
        "width": "75%"
      }
    }, [_vm._v("\n          " + _vm._s(type.title) + "\n        ")]), _vm._v(" "), _c('th', {
      staticClass: "text-right"
    }, [_vm._v("\n          " + _vm._s(type.sum) + "\n        ")])])]), _vm._v(" "), _c('tbody', [(type.events.length < 1) ? _c('tr', [_c('td', {
      staticClass: "text-explainer"
    }, [_vm._v("Ingen "), (idx === 0) ? _c('span', [_vm._v("lektioner")]) : _vm._e(), (idx === 1) ? _c('span', [_vm._v("UUV")]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _vm._l((type.events), function(task) {
      return _c('tr', [_c('td', {
        staticStyle: {
          "width": "75%"
        }
      }, [_c('div', {
        staticClass: "subject-and-calendar"
      }, [_c('div', {
        staticClass: "d-subject",
        style: ({
          'border-left-color': task.color
        })
      }, [_vm._v(_vm._s(task.name))]), _vm._v("\n            " + _vm._s(task.calendar) + "\n          ")])]), _vm._v(" "), _c('td', {
        staticClass: "text-right"
      }, [_vm._v(_vm._s(task.hours))])])
    })], 2)])
  })]], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-46ceca22!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Reporting/StilRessourceTasks.vue
// module id = 1577
// module chunks = 1